import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { IntlShape, useIntl } from 'react-intl';
import { z } from 'zod';
import { CustomPrecision } from '../types';
import { precisionSchema } from '../utils';

const customPrecisionErrorMap =
  (intl: IntlShape): z.ZodErrorMap =>
  (issue, ctx) => {
    if (issue.code === 'invalid_type') {
      return {
        message: intl.formatMessage({
          id: 'containers.settings.queues.queue.automation.optimization.table.errors.customPrecisionInvalidType',
        }),
      };
    }

    if (issue.code === 'too_big' || issue.code === 'too_small') {
      return {
        message: intl.formatMessage({
          id: 'containers.settings.queues.queue.automation.optimization.table.errors.customPrecisionOutOfRange',
        }),
      };
    }

    return { message: ctx.defaultError };
  };

export const useOptimizationForm = () => {
  const intl = useIntl();

  return useForm<CustomPrecision>({
    defaultValues: {},
    mode: 'onChange',
    resolver: zodResolver(z.record(precisionSchema), {
      errorMap: customPrecisionErrorMap(intl),
    }),
  });
};
